module.exports = __webpack_public_path__ + "img/gl.bc010f86.jpg";